import script from "./PermissionIndex.vue?vue&type=script&setup=true&lang=ts"
export * from "./PermissionIndex.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__